import { useConfig } from '../context/ConfigProvider/ConfigProvider';
export const useGetTestIdAttribute = () => {
    const { testIdAttributeName } = useConfig();
    return (testId) => {
        return testId
            ? {
                [testIdAttributeName]: testId,
            }
            : {};
    };
};
export const useTestIdAttribute = (testId) => {
    const getTestIdAttribute = useGetTestIdAttribute();
    return getTestIdAttribute(testId);
};
